import type { PropsWithChildren } from 'react'

import NavbarLeft from '../_sections/navigation/navbar_left'
import { Footer } from '../relume-sections/pfrg/footer'
import { Outlet } from '@remix-run/react'
import { useRootLoaderData } from '@/root.tsx'

type NavLink = {
	url: string
	title: string
}

function extractNavLinks(navbarData: {
	navbar_items: Array<{
		id: number
		title: string
		page: { seo: { slug: string } }
	}>
}): NavLink[] {
	if (!navbarData) {
		return []
	}

	if (!navbarData.navbar_items) {
		return []
	}
	return navbarData.navbar_items.map((item) => ({
		url: item.page.seo.slug,
		title: item.title,
	}))
}

export default function PFG({ children }) {
	const { brand, navigation } = useRootLoaderData()

	// TODO: Location Chooser:
	// Get users location and set the location in local storage the closest restaurant location to them if it's within 20 miles or whatevers easy. If we can't easily get a location or they're further than 20 miles from the nearest location, set location to choose location.
	// Location chooser is in the header section so it'll get set based off of what's in local storage.
	// the serverside value will be the default location but will have to be updated on the client side.
	// TODO:

	if (!navigation || navigation === undefined) {
		return <div>Loading...</div>
	}

	const navLinks = extractNavLinks(navigation)
	return (
		<main className="pfg font-poppins relative flex w-full flex-col place-items-center items-stretch bg-background">
			<div className="flex h-screen flex-col justify-between bg-background">
				<div className="absolute top-0 z-[999] w-full">
					<header className="container z-[999] w-full">
						<nav className="flex flex-wrap items-center justify-between gap-4 sm:flex-nowrap md:gap-8">
							<NavbarLeft navLinks={navLinks} />
						</nav>
					</header>
				</div>

				<div className="flex-1">{children}</div>

				<div className="container">
					<Footer />
				</div>
			</div>
		</main>
	)
}
